<template>
  <div v-if="!screen.isDesktop && initialReviewFilter && counter.notVerified <= 0">
    <div v-if="isLoadReview || (!isLoadReview && reviewsData.length)" id="reviewProduct" class="review-product">
      <div class="filter-bar-content">
        <template v-if="isLoadReview">
          <div
            v-for="(rev, i) in 6"
            :key="rev._id + '_' + i"
            class="card-timeline--uniform review element-placeholder placeholder"
          >
            <div class="available-share">
              <div class="card-userinfo--uniform">
                <div src="" class="avatar placeholder"></div>
                <div class="userinfo placeholder">
                  <span
                    class="see-all-user-review placeholder"
                    style="width: 150px; min-height: 0px; height: 20px !important; display: block; min-height: 0"
                  ></span>
                </div>
              </div>
              <div class="card-content placeholder">
                <div class="d-block">
                  <div class="average-rating--uniform">
                    <div class="rating--uniform timeline-review">
                      <div v-if="rev.average_rating" :class="`rate-star--uniform rate-star--uniform-50 biger-star`">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span v-if="rev.average_rating" class="count">5</span>
                    </div>
                  </div>

                  <span v-if="rev.product" class="shade">{{ rev.product.variant }}</span>
                  <strong>
                    <template></template>
                  </strong>
                  <p class="desc placeholder" v-html="rev.details"></p>
                </div>
              </div>
            </div>
            <div class="action-bottom-card-timeline--uniform placeholder">
              <div class="left"></div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
  <div v-else-if="screen.isDesktop || (!screen.isDesktop && isUserUsingFilter) || !initialReviewFilter">
    <div id="reviewProduct" class="review-product">
      <div class="filter-bar" :class="{ 'is-loading': isLoadReview }">
        <FilterReview
          v-if="counterInitial.notVerified > 0"
          ref="filterReview"
          :tabs="tabsReview"
          :filter="newFilters"
          :options="options"
          :product="product"
          :count="reviewsData && reviewsData.length ? reviewsData.length : 0"
          :initial="initialReviewFilter"
          :wrapped-filter="false"
          :reviews="reviewsData"
          :scroll-position="scrollPosition"
          @changeTab="(x) => changeTabActive(x.value)"
          @submit="applyFilterReview"
          @reset="resetFilterDesktop(true)"
        />
      </div>

      <div class="filter-bar-content" :class="{ 'expert-bg': newFilters.tabName === 'expert-review' }">
        <template v-if="isLoadReview">
          <div
            v-for="(rev, i) in 6"
            :key="rev._id + '_' + i"
            class="card-timeline--uniform review element-placeholder placeholder"
          >
            <div class="available-share">
              <div class="card-userinfo--uniform">
                <div src="" class="avatar placeholder"></div>
                <div class="userinfo placeholder">
                  <span
                    class="see-all-user-review placeholder"
                    style="width: 150px; min-height: 0px; height: 20px !important; display: block; min-height: 0"
                  ></span>
                </div>
              </div>
              <div class="card-content placeholder">
                <div class="d-block">
                  <div class="average-rating--uniform">
                    <div class="rating--uniform timeline-review">
                      <div v-if="rev.average_rating" :class="`rate-star--uniform rate-star--uniform-50 biger-star`">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span v-if="rev.average_rating" class="count">5</span>
                    </div>
                  </div>

                  <span v-if="rev.product" class="shade">{{ rev.product.variant }}</span>
                  <strong>
                    <template></template>
                  </strong>
                  <p class="desc placeholder" v-html="rev.details"></p>
                </div>
              </div>
            </div>
            <div class="action-bottom-card-timeline--uniform placeholder">
              <div class="left"></div>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="Object.keys(reviewsData).length">
            <template v-if="screen.isDesktop">
              <CardReviewDetailV2
                v-for="review in reviewsData"
                :key="review._id"
                :show-product="false"
                :review-data="review"
                :is-expert-review="
                  (review.user && review.user.is_expert_reviewer) || (review.owner && review.owner.is_expert_reviewer)
                "
                on="product"
                @apply-filter="applyFilterReview"
              />
            </template>

            <CardReviewDetail
              v-for="review in reviewsData"
              v-else
              :key="review._id"
              :show-product="false"
              :review-data="review"
              :is-expert-review="
                (review.user && review.user.is_expert_reviewer) || (review.owner && review.owner.is_expert_reviewer)
              "
              on="product"
              @apply-filter="applyFilterReview"
            />
          </template>

          <template v-else>
            <div v-if="showAddReview" class="d-flex no-filtered-product no-verified-pro">
              <img
                :src="`/assets/img/${
                  tabActive === 'review-with-photos' ? 'icon-no-result-review-photo' : 'icon-no-result-review'
                }.svg`"
                loading="lazy"
                alt="Add review"
              />
              <template v-if="tabActive === 'all-review'">
                <h2>Be The First To Review This Product</h2>
                <p>Habis belanja cantik di Sociolla? Yuk, bagikan pengalamanmu dan tulis review!</p>
              </template>
              <template v-else-if="tabActive === 'trusted-review'">
                <h2>No Trusted Review</h2>
                <p>Habis belanja cantik di Sociolla? Yuk, bagikan pengalamanmu dan tulis review!</p>
              </template>
              <template v-else-if="tabActive === 'expert-review'">
                <h2>No Expert Review</h2>
                <p>Habis belanja cantik di Sociolla? Yuk, bagikan pengalamanmu dan tulis review!</p>
              </template>
              <template v-else>
                <h2>No Review With Photos</h2>
                <p>Yuk, lengkapi Review-mu dengan membagikan foto produk yang kamu coba!</p>
              </template>
              <!-- <button
                v-if="$store.state.auth.loggedin"
                class="btn btn-red center-block"
                @click.prevent="$router.push(`/review/add/${product_id}`)"
              >
                Add review
              </button>
              <button v-else class="btn btn-red center-block" @click.prevent="$store.dispatch('loginOtf')">
                Add review
              </button> -->
              <button v-if="screen.isDesktop" class="btn btn-red center-block" @click.prevent="resetFilterDesktop">
                Reset filter
              </button>
              <button v-else class="btn btn-red center-block" @click.prevent="resetFilterMobile">Reset filter</button>
            </div>
            <div v-else class="d-flex no-filtered-product no-verified-pro">
              <img
                :src="`/assets/img/${
                  tabActive === 'review-with-photos' ? 'icon-no-result-review-photo' : 'icon-no-result-review'
                }.svg`"
                loading="lazy"
                alt="Reset filter"
              />
              <template v-if="tabActive === 'all-review'">
                <h2>No Result</h2>
                <p>Review yang sesuai dengan filter tersebut tidak dapat ditemukan.</p>
              </template>
              <template v-else-if="tabActive === 'expert-review'">
                <h2>No Expert Review</h2>
                <p>Habis belanja cantik di Sociolla?<br />Yuk, bagikan pengalamanmu dan tuliskan Review!</p>
              </template>
              <template v-else-if="tabActive === 'trusted-review'">
                <h2>No Trusted Review</h2>
                <p>Habis belanja cantik di Sociolla?<br />Yuk, bagikan pengalamanmu dan tuliskan Review!</p>
              </template>
              <template v-else>
                <h2>No Review With Photos</h2>
                <p>Yuk, lengkapi Review-mu dengan membagikan foto produk yang kamu coba!</p>
              </template>
              <template>
                <button v-if="screen.isDesktop" class="btn btn-red center-block" @click.prevent="resetFilterDesktop">
                  Reset filter
                </button>
                <button v-else class="btn btn-red center-block" @click.prevent="resetFilterMobile">Reset filter</button>
              </template>
            </div>
          </template>
        </template>
      </div>

      <div v-if="isActiveInfiniteLoadingState || !useButtonToLoadMore">
        <infinite-loading @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
          <div slot="spinner"><GLoaderSpin :text="loadMoreLoadingText ? 'Load review..' : ''" /></div>
        </infinite-loading>
      </div>
      <div v-else>
        <div v-if="isShowPaginationAll" class="container-btn hidden-lg hidden-md">
          <a v-if="isProcessingLoadMore" href="" class="btn btn-loadmore btn-block" @click.prevent>Load..</a>
          <a v-else href="" class="btn btn-loadmore btn-block" @click.prevent="loadMore()">Load More Reviews</a>
        </div>

        <div v-if="isShowPaginationExpert" class="container-btn hidden-lg hidden-md">
          <a v-if="isProcessingLoadMore" href="" class="btn btn-loadmore btn-block" @click.prevent>Load..</a>
          <a v-else href="" class="btn btn-loadmore btn-block" @click.prevent="loadMore()">Load More Reviews</a>
        </div>

        <div v-if="isShowPaginationVerified" class="container-btn hidden-lg hidden-md">
          <a v-if="isProcessingLoadMore" href="" class="btn btn-loadmore btn-block" @click.prevent>Load..</a>
          <a v-else href="" class="btn btn-loadmore btn-block" @click.prevent="loadMore()">Load More Reviews</a>
        </div>

        <div v-if="isShowPaginationWithPhotos" class="container-btn hidden-lg hidden-md">
          <a v-if="isProcessingLoadMore" href="" class="btn btn-loadmore btn-block" @click.prevent>Load..</a>
          <a v-else href="" class="btn btn-loadmore btn-block" @click.prevent="loadMore()">Load More Reviews</a>
        </div>
      </div>

      <div class="hidden-sm hidden-xs">
        <div v-if="isShowPaginationAll">
          <Pagination
            v-if="counter.notVerified > limit"
            key="Pagination"
            ref="paginationProduct"
            :limit="limit"
            :skip="skip"
            :total-item="counter.notVerified"
            @skipTo="skipTo"
          />
        </div>

        <div v-if="isShowPaginationExpert" class="d-flex">
          <Pagination
            v-if="counter.verified > limit"
            key="Pagination"
            ref="paginationProduct"
            :limit="limit"
            :skip="skip"
            :total-item="counter.expert"
            @skipTo="skipTo"
          />
        </div>

        <div v-if="isShowPaginationVerified" class="d-flex">
          <Pagination
            v-if="counter.verified > limit"
            key="Pagination"
            ref="paginationProduct"
            :limit="limit"
            :skip="skip"
            :total-item="counter.verified"
            @skipTo="skipTo"
          />
        </div>

        <div v-if="isShowPaginationWithPhotos" class="d-flex">
          <Pagination
            v-if="counter.withPhotos > limit"
            key="Pagination"
            ref="paginationProduct"
            :limit="limit"
            :skip="skip"
            :total-item="counter.withPhotos"
            @skipTo="skipTo"
          />
        </div>
      </div>

      <ModalReport />
    </div>
  </div>
</template>

<script>
import CardReviewDetailV2 from '@/components/dashboard/snippet/card-review-detail-v2';
import CardReviewDetail from '@/components/dashboard/snippet/card-review-detail';
import ModalReport from '@/components/global/modal/modal-report';
// import Dropdown from '@/components/global/dropdown/dropdown';
import jsonld from '@/shared/jsonld';
import Pagination from '@/components/global/pagination/pagination';
import { get } from 'lodash';
import Auth from '@/shared/auth';

let infiniteLoadingStateReference;

// const moment = require('moment');
// moment.locale('id');

export default {
  name: 'FilteredReviews',
  components: {
    CardReviewDetailV2,
    CardReviewDetail,
    ModalReport,
    // Dropdown,
    // FilterByUserLevelMobile: () => import('@/components/global/filter-by-user-level/filter-by-user-level-mobile'),
    // FilterBySkinTypeMobile: () => import('@/components/global/filter-by-skin-type/filter-by-skin-type-mobile'),
    // FilterByRatingMobile: () => import('@/components/global/filter-by-rating/filter-by-rating-mobile'),
    // FilterBySortMobile: () => import('@/components/global/filter-by-sort/filter-by-sort-mobile'),
    Pagination,
    FilterReview: () => import('@/components/global/filter-review/filter-review'),
  },
  // props: ['product'],
  props: {
    product: {
      type: Object,
      required: true,
    },
    is_section: {
      type: Boolean,
      required: true,
    },
    autoFetch: {
      type: Boolean,
      required: false,
      default: false,
    },
    useButtonToLoadMore: {
      type: Boolean,
      required: false,
      default: true,
    },
    loadMoreLoadingText: {
      type: Boolean,
      required: false,
      default: true,
    },
    scrollPosition: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data() {
    return {
      activeDropdown: null,
      activeShareReview: null,
      filterRatingChecked: '',
      isLoadReview: false,
      pager: 1,
      skip: 0,
      limit: 6,
      showFilter: null,
      filters: {
        skinType: null,
        hairType: null,
        userLevel: null,
        ratings: null,
        age: null,
        sorter: '-total_likes -created_at -average_rating',
        verfiedReview: false,
      },
      newFilters: {
        tabName: 'all-review',
        verfiedReview: false,
        valueAge: null,
      },
      counter: {
        notVerified: 0,
        expert: 0,
        verified: 0,
        withPhotos: 0,
        totalLiked: 0,
      },
      counterInitial: {
        notVerified: 0,
        expert: 0,
        verified: 0,
        withPhotos: 0,
      },
      isActiveInfiniteLoadingState: false,
      isProcessingLoadMore: false,
      toggleTextUserLevel: 'All User Level',
      toggleTextHairType: 'All Hair Type',
      toggleTextSkinType: 'All Skin Type',
      toggleTextSortDate: 'Newest',
      toggleMostHelpfulText: 'Most Helpful',
      toggleTextRating: 'All Ratings',
      toggleTextAgeRange: 'All Age Range',
      tabActive: 'all-review',
      showUserlevel: [],
      mostHepfull: false,
      defaultSorter: '-total_likes -created_at -average_rating',
      initialReviewFilter: true,
    };
  },
  computed: {
    reviewsData() {
      return this.$store.state.review.product;
    },
    forcePager() {
      return this.skip == 0 ? 1 : null;
    },
    isLogin: {
      get: function () {
        return this.$store.state.auth.loggedin;
      },
      set: function (value) {
        return value;
      },
    },
    isUserUsingFilter() {
      return (
        this.filters.skinType ||
        this.filters.userLevel ||
        this.filters.ratings ||
        this.filters.ratings === 0 ||
        (this.filters.sorter !== '-created_at' &&
          this.filters.sorter !== '-total_likes' &&
          Boolean(this.filters.sorter)) ||
        this.filters.age ||
        (this.newFilters.combinations && this.newFilters.combinations.length) ||
        (this.newFilters.valueAge && this.newFilters.valueAge.length) ||
        (this.newFilters.skin && this.newFilters.skin.length) ||
        (this.newFilters.rating && this.newFilters.skin.length) ||
        this.newFilters.tabName
      );
    },
    product_id() {
      const id = this.$route.params.product_id.split('-');
      if (id[0]) {
        return id[0];
      } else {
        return null;
      }
    },
    screen() {
      return this.$store.state.screen;
    },
    isShowPaginationAll() {
      return (
        this.$SO.size(this.reviewsData) && this.counter.notVerified >= this.limit && this.tabActive === 'all-review'
      );
    },
    isShowPaginationExpert() {
      return this.$SO.size(this.reviewsData) && this.counter.expert >= this.limit && this.tabActive === 'expert-review';
    },
    isShowPaginationVerified() {
      return (
        this.$SO.size(this.reviewsData) && this.counter.verified >= this.limit && this.tabActive === 'trusted-review'
      );
    },
    isShowPaginationWithPhotos() {
      return (
        this.$SO.size(this.reviewsData) &&
        this.counter.withPhotos >= this.limit &&
        this.tabActive === 'review-with-photos'
      );
    },
    toggleTextRatingMobile() {
      return `${this.toggleTextRating} <img src="/assets/img/icons/arrow-dropdown.svg" class="dropdown__icon" alt="dropdown-icon">`;
    },
    tooltipOptions() {
      const triggerValue = this.screen.isDesktop ? 'hover' : 'click';
      const placementValue = this.screen.isDesktop ? 'bottom-start' : 'auto';
      return {
        content:
          'Review terpercaya dari user yang membeli produk kecantikan di Sociolla atau mendapatkan produk kecantikan dari program sampling kami',
        trigger: triggerValue,
        placement: placementValue,
      };
    },
    options() {
      const category = get(this.product, 'categories[0].name', get(this.product, 'category.name', ''));
      let typeName = '';
      let list = [];
      if (category === 'Hair Care') {
        typeName = 'Hair Type';
        list = [
          { name: 'Rambut Normal', value: 'Rambut Normal' },
          { name: 'Rambut Ketombe', value: 'Rambut Ketombe' },
          { name: 'Rambut Rontok', value: 'Rambut Rontok' },
          { name: 'Rambut Bercabang', value: 'Rambut Bercabang' },
          { name: 'Rambut Frizzy', value: 'Rambut Frizzy' },
          { name: 'Rambut Tipis', value: 'Rambut Tipis' },
          { name: 'Rambut Diwarnai', value: 'Rambut Diwarnai' },
          { name: 'Rambut Rusak', value: 'Rambut Rusak' },
        ];
      } else {
        typeName = 'Skin Type';
        list = [
          { name: 'Kulit Normal', value: 'Kulit Normal' },
          { name: 'Kulit Kering', value: 'Kulit Kering' },
          { name: 'Kulit Berminyak', value: 'Kulit Berminyak' },
          { name: 'Kulit Kombinasi', value: 'Kulit Kombinasi' },
          { name: 'Kulit Sensitif', value: 'Kulit Sensitif' },
        ];
      }
      return { helpful: true, order: true, skin: { title: typeName, filter: list }, rating: true, age: true };
    },
    tabsReview() {
      const data = [];
      if (this.product) {
        data.push({
          name: 'All (' + this.$options.filters.cnvrtNumberToK(this.counter.notVerified) + ')',
          value: 'all-review',
          count: `${this.$options.filters.cnvrtNumberToK(this.counter.notVerified)}`,
        });
        data.push({
          name: 'Expert (' + this.$options.filters.cnvrtNumberToK(this.counter.expert) + ')',
          value: 'expert-review',
          count: `${this.$options.filters.cnvrtNumberToK(this.counter.expert)}`,
        });
        data.push({
          name: 'Shopper (' + this.$options.filters.cnvrtNumberToK(this.counter.verified) + ')',
          value: 'trusted-review',
          count: `${this.$options.filters.cnvrtNumberToK(this.counter.verified)}`,
        });
        data.push({
          name:
            'With Photos (' +
            (this.counter.withPhotos ? this.$options.filters.cnvrtNumberToK(this.counter.withPhotos) : 0) +
            ')',
          value: 'review-with-photos',
          count: this.counter.withPhotos ? `${this.$options.filters.cnvrtNumberToK(this.counter.withPhotos)}` : 0,
        });
      }
      return data;
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    isBeautyProfileCompleted() {
      const { user } = this;
      return Boolean(
        user &&
          user.beauty &&
          user.beauty.length &&
          !this.$SO.isEmptyObject(user.beauty.find((beauty) => beauty.type === 'beauty-profile'))
      );
    },
    showAddReview() {
      const {
        initialReviewFilter,
        product: { is_reviewed, is_reviewed_combination, review_stats },
        counter: { verified, withPhotos, expert },
        tabActive,
      } = this;
      return (
        (initialReviewFilter || (!initialReviewFilter && !(is_reviewed && is_reviewed_combination))) &&
        ((verified === 0 && tabActive === 'trusted-review') ||
          (expert === 0 && tabActive === 'expert-review') ||
          (withPhotos === 0 && tabActive === 'review-with-photos') ||
          (review_stats && review_stats.total_reviews === 0 && tabActive === 'all-review'))
      );
    },
    newSorter() {
      const sorter = (mostRelevant) => {
        const defaultSorter = '-total_likes -created_at';
        if (this.newFilters.sort && this.newFilters.sort.value) {
          return this.newFilters.sort.value === '-total_likes' ? defaultSorter : this.newFilters.sort.value;
        } else {
          return mostRelevant || defaultSorter;
        }
      };
      if (this.isLogin) {
        if (this.isBeautyProfileCompleted) {
          return sorter('most_relevant');
        } else {
          return sorter();
        }
      } else {
        return sorter();
      }
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(val) {
        this.resetParamsPaginationAndLoadMore();
        this.getReviewsCount(false);
      },
    },
    product_id(id) {
      if (this.screen.isDesktop) {
        this.resetFilterDesktop();
      } else {
        this.resetFilterMobile();
      }
      this.skip = 0;
      this.getReviewsCount();
    },
    isLogin(newVal) {
      if (newVal) {
        this.filters.sorter = '-total_likes';
        if (this.reviewsData && this.reviewsData.length) {
          this.mostHepfull = !this.mostHepfull;
        } else {
          this.mostHepfull = false;
        }
      } else {
        this.filters.sorter = '-created_at';
      }
    },
    $route() {
      this.initialReviewFilter = true;
    },
    is_section: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.fetchAll();
        }
      },
    },
  },
  created() {
    // this.setDefault();
    // this.getReviewsCount();
    // this.getUserLevel()
  },
  mounted() {
    if (this.autoFetch) {
      this.fetchAll();
    }
  },
  methods: {
    applyFilterReview(data, tabChanged = false) {
      this.newFilters = Object.assign({}, { ...data });
      this.resetParamsPaginationAndLoadMore();
      if (this.$route.query && this.$route.query.page != 1) {
        this.$router.push(
          `${this.$options.filters.productUrlReview(this.product)}?${this.$options.filters.serializeQS({
            page: 1,
          })}`
        );
      }
      if ((data.hasOwnProperty('fetch') && data.fetch) || !data.hasOwnProperty('fetch')) {
        // this.getReviewsCount(false);
      }
      this.initialReviewFilter = false;
      if (!tabChanged) {
        this.getReviewsCount(false);
      }
      this.getreviewsData();
    },
    resetAll() {
      this.counter.notVerified = 0;
      this.counter.expert = 0;
      this.counter.verified = 0;
      this.counter.withPhotos = 0;
      this.counter.totalLiked = 0;
      this.$store.commit('review/SET_REVIEW', {
        reviews: null,
        on: 'product',
      });
    },
    setDefault() {
      if (this.$store.state.auth.loggedin) {
        this.mostHepfull = !this.mostHepfull;
        this.newFilters['sort'] = this.isBeautyProfileCompleted ? 'most_relevant' : '-total_likes';
      }
      this.newFilters['helpful'] = ['-total_likes'];
      // this.newFilters['order'] = '-created_at';
      // this.newFilters['average_rating'] = '-average_rating';
    },
    addJsonLd() {
      const jsonldObject = { review: [] };
      let mergeObjectJsonLd;
      if (this.counter.notVerified) {
        this.$SO.each(this.reviewsData, (key, review) => {
          const reviewJsonLd = {
            '@type': 'Review',
            datePublished: `${this.$options.filters.dMyyyy(review.created_at)}`,
            reviewBody: `${this.$options.filters.stripHTML(review.details)}`,
            reviewRating: {
              '@type': 'Rating',
              worstRating: 1,
              ratingValue: Number(Number(review.average_rating).toFixed(1)),
              bestRating: 5,
            },
            author: {
              '@type': 'Person',
              name: review.owner.name,
            },
          };
          jsonldObject.review.push(reviewJsonLd);
        });
        mergeObjectJsonLd = Object.assign(jsonld.data, jsonldObject);
        jsonld.setData(mergeObjectJsonLd);
        jsonld.append(jsonld.data);
      }
    },
    doCopy(url) {
      this.$copyText(url).then(
        (e) => {
          this.$toasted.show('Link copied');
        },
        function (e) {
          this.$toasted.show('Can not copy the link');
        }
      );
    },
    infiniteHandler($state) {
      infiniteLoadingStateReference = $state;
      this.loadMore($state);
    },
    onChangeSkinType(newText) {
      const textFilterForChangeSkin = newText !== 'All Skin Type' ? newText : null;
      this.toggleTextSkinType = newText;
      this.changeSkinType(textFilterForChangeSkin);
    },
    onChangeHairType(newText) {
      const textFilterForChangeHair = newText !== 'All Hair Type' ? newText : null;
      this.toggleTextHairType = newText;
      this.changeHairType(textFilterForChangeHair);
    },
    onChangeAgeRange(newText) {
      const textFilterForAgeRange = newText !== 'All Age Range' ? newText : null;
      this.toggleTextAgeRange = newText;
      this.changeAgeRange(textFilterForAgeRange);
    },
    onChangeUserLevel(newText) {
      const textFilterForChangeLevel = newText !== 'All User Level' ? newText : null;
      this.toggleTextUserLevel = newText;
      this.changeUserLevel(textFilterForChangeLevel);
    },
    onChangeSortDate(newText) {
      let newTextAfterModify;
      if (newText === 'Newest') {
        newTextAfterModify = '-created_at';
      } else if (newText === 'Oldest') {
        newTextAfterModify = 'created_at';
      }
      this.toggleTextSortDate = newText;
      this.changeSorterV2(newTextAfterModify);
    },
    onMostHelpful(newText) {
      let newTextAfterModify;
      if (newText === 'Most Helpful') {
        newTextAfterModify = '-total_likes';
        this.mostHepfull = !this.mostHepfull;
      }
      this.toggleMostHelpfulText = newText;
      this.changeSorterV2(newTextAfterModify);
    },
    onChangeRating(newText) {
      let newTextAfterModify;
      if (
        newText ===
        `<img height='16px' class='rating-desktop' src='/assets/img/icons/five-stars.png' alt='icon-rating'/> 5`
      ) {
        newText = `<img height='16px' class='rating-desktop' src='/assets/img/icons/5-star.svg' alt='icon-rating'/> 5`;
      } else if (
        newText ===
        `<img height='16px' class='rating-desktop' src='/assets/img/icons/four-stars.png' alt='icon-rating'/> 4`
      ) {
        newText = `<img height='16px' class='rating-desktop' src='/assets/img/icons/4-star.svg' alt='icon-rating'/> 4`;
      } else if (
        newText ===
        `<img height='16px' class='rating-desktop' src='/assets/img/icons/three-stars.png' alt='icon-rating'/> 3`
      ) {
        newText = `<img height='16px' class='rating-desktop' src='/assets/img/icons/3-star.svg' alt='icon-rating'/> 3`;
      } else if (
        newText ===
        `<img height='16px' class='rating-desktop' src='/assets/img/icons/two-stars.png' alt='icon-rating'/> 2`
      ) {
        newText = `<img height='16px' class='rating-desktop' src='/assets/img/icons/2-star.svg' alt='icon-rating'/> 2`;
      } else if (
        newText ===
        `<img height='16px' class='rating-desktop' src='/assets/img/icons/one-stars.png' alt='icon-rating'/> 1`
      ) {
        newText = `<img height='16px' class='rating-desktop' src='/assets/img/icons/1-star.svg' alt='icon-rating'/> 1`;
      } else {
        newText = newText;
      }
      this.toggleTextRating = newText;

      if (/five-stars/.test(newText) || /5-star/.test(newText)) {
        newTextAfterModify = 5;
      } else if (/four-stars/.test(newText) || /4-star/.test(newText)) {
        newTextAfterModify = 4;
      } else if (/three-stars/.test(newText) || /3-star/.test(newText)) {
        newTextAfterModify = 3;
      } else if (/two/.test(newText) || /2-star/.test(newText)) {
        newTextAfterModify = 2;
      } else if (/one/.test(newText) || /1-star/.test(newText)) {
        newTextAfterModify = 1;
      } else if (/zero/.test(newText)) {
        newTextAfterModify = 0;
      } else {
        newTextAfterModify = null;
      }
      this.filterRatingChecked = newTextAfterModify;
      this.changeRatings(newTextAfterModify);
    },
    openFilterByRating() {
      this.$store.commit('setFilterProduct', { filterName: 'rating', value: true });
    },
    openFilterBySort() {
      this.$store.commit('setFilterProduct', { filterName: 'sorting', value: true });
    },
    openFilterByUserLevel() {
      this.$store.commit('setFilterProduct', { filterName: 'userLevel', value: true });
    },
    openFilterBySkinType() {
      this.$store.commit('setFilterProduct', { filterName: 'skinType', value: true });
    },
    resetFilterDesktop(data = false) {
      // this.filters.skinType = null
      // this.filters.hairType = null
      // this.filters.userLevel = null
      // this.filters.ratings = null
      // this.filters.sorter = '-created_at'
      // this.filters.age = null

      // this.toggleTextSkinType = 'All Skin Type'
      // this.toggleTextHairType = 'All Hair Type'
      // this.toggleTextUserLevel = 'All User Level'
      // this.toggleTextRating = 'All Ratings'
      // this.toggleTextSortDate = 'Newest'
      // this.toggleTextAgeRange = 'All Age Range'
      this.tabActive = 'all-review';
      this.newFilters = Object.assign(
        {},
        {
          tabName: 'all-review',
          verfiedReview: false,
          valueAge: null,
        }
      );
      if (this.$refs.filterReview) {
        this.$refs.filterReview.resetPillFilter();
        // this.$refs.filterReview.setData(null, false);
      }
      if (data) {
        this.applyFilterReview(this.newFilters);
      }
    },
    resetFilterMobile(data = false) {
      // this.filters.skinType = null
      // this.filters.hairType = null
      // this.filters.userLevel = null
      // this.filters.ratings = null
      // this.filters.sorter = '-created_at'
      // this.filters.age = null

      // this.toggleTextSkinType = 'All Skin Type'
      // this.toggleTextHairType = 'All Hair Type'
      // this.toggleTextUserLevel = 'All User Level'
      // this.toggleTextRating = 'All Ratings'
      // this.toggleTextSortDate = 'Newest'
      // this.toggleTextAgeRange = 'All Age Range'
      this.tabActive = 'all-review';
      this.newFilters = Object.assign(
        {},
        {
          tabName: 'all-review',
          verfiedReview: false,
          valueAge: null,
        }
      );
      // this.setDefault()
      if (this.$refs.filterReview) {
        this.$refs.filterReview.resetPillFilter();
        // this.$refs.filterReview.setData(null, false);
      }
      if (data) {
        this.applyFilterReview(this.newFilters);
      }
    },
    resetParamsPaginationAndLoadMore() {
      this.skip = 0;
      if (infiniteLoadingStateReference) {
        infiniteLoadingStateReference.reset();
        infiniteLoadingStateReference = undefined;
      }
      this.isActiveInfiniteLoadingState = false;
    },
    changeSorter(val) {
      if (this.filters.sorter === '-total_likes') {
        this.filters.sorter = this.filters.sorter + ',' + val;
      } else {
        this.filters.sorter = val;
      }
    },
    changeSorterV2(val) {
      // return to default sorter if user toggled it
      if (val === this.filters.sorter) {
        this.filters.sorter = this.defaultSorter;
      } else {
        if (val !== '-total_likes') {
          // deactivate most helpful filter
          // when user click sort by date (newest or oldest)
          if (this.mostHepfull) {
            this.mostHepfull = !this.mostHepfull;
          }
        } else {
          // deactivate sort by date filter and return it to Newest (default)
          // when user click sort by most helpful
          // and active sort by date filter is the Oldest
          if (this.filters.sorter !== this.defaultSorter) {
            this.toggleTextSortDate = 'Newest';
          }
        }
        this.filters.sorter = val;
      }
    },
    changeRatings(val) {
      this.filters.ratings = val;
    },
    changeSkinType(val) {
      this.filters.skinType = val;
    },
    changeHairType(val) {
      this.filters.hairType = val;
    },
    changeAgeRange(val) {
      let birthdate;
      let gteRangeDate;
      let lteRangeDate = '';
      if (val === '< 18 th') {
        gteRangeDate = dayjs(new Date()).subtract(18, 'years');
        gteRangeDate = gteRangeDate.toISOString();
        birthdate = { $gte: `${gteRangeDate}` };
        this.filters.age = birthdate;
      } else if (val === '19 - 24 th') {
        gteRangeDate = dayjs(new Date()).subtract(24, 'years');
        gteRangeDate = gteRangeDate.toISOString();
        lteRangeDate = dayjs(new Date()).subtract(19, 'years');
        lteRangeDate = lteRangeDate.toISOString();
        birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
        this.filters.age = birthdate;
      } else if (val === '25 - 29 th') {
        gteRangeDate = dayjs(new Date()).subtract(29, 'years');
        gteRangeDate = gteRangeDate.toISOString();
        lteRangeDate = dayjs(new Date()).subtract(25, 'years');
        lteRangeDate = lteRangeDate.toISOString();
        birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
        this.filters.age = birthdate;
      } else if (val === '30 - 34 th') {
        gteRangeDate = dayjs(new Date()).subtract(34, 'years');
        gteRangeDate = gteRangeDate.toISOString();
        lteRangeDate = dayjs(new Date()).subtract(30, 'years');
        lteRangeDate = lteRangeDate.toISOString();
        birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
        this.filters.age = birthdate;
      } else if (val === '35 - 39 th') {
        gteRangeDate = dayjs(new Date()).subtract(39, 'years');
        gteRangeDate = gteRangeDate.toISOString();
        lteRangeDate = dayjs(new Date()).subtract(35, 'years');
        lteRangeDate = lteRangeDate.toISOString();
        birthdate = { $gte: `${gteRangeDate}`, $lte: `${lteRangeDate}` };
        this.filters.age = birthdate;
      } else if (val === '> 40 th') {
        lteRangeDate = dayjs(new Date()).subtract(40, 'years');
        lteRangeDate = lteRangeDate.toISOString();
        birthdate = { $lte: `${lteRangeDate}` };
        this.filters.age = birthdate;
      } else {
        this.filters.age = val;
      }
    },
    changeUserLevel(val) {
      this.filters.userLevel = val;
    },
    changeTabActive(val) {
      this.isLoadReview = true;
      this.tabActive = val;
      this.newFilters.tabName = val;
      this.applyFilterReview(this.newFilters, true);
    },
    toggleFilter(byWhat) {
      if (byWhat == this.showFilter) {
        this.showFilter = null;
      } else {
        this.showFilter = byWhat;
      }
    },
    closeShareReview() {
      this.activeShareReview = null;
    },
    skipTo(pagination) {
      this.skip = this.limit * (pagination.number - 1);
      this.getreviewsData(true);
      this.$router.push(
        `${this.$options.filters.productUrlReview(this.product)}?${this.$options.filters.serializeQS({
          page: pagination.number,
        })}`
      );
    },
    toggleShareReview(id) {
      if (this.activeShareReview == id) {
        this.activeShareReview = null;
      } else {
        this.activeShareReview = id;
      }
    },
    closeDropdown() {
      this.activeDropdown = null;
    },
    toggleDropdown(id) {
      if (this.activeDropdown == id) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = id;
      }
    },
    //   getUserLevel() {
    // 	this.$MS_SOCO_PUBLIC_API_URL
    // 		.get(`/rewards`, {
    // 			params: {
    // 				fields: 'name'
    // 			}
    // 		})
    // 		.then(res => {
    // 			if (res.status == 200 && res.data.success) {
    // 				const data = res.data.data.filter(f=>f.name!='Diamond Clique')
    // 				this.showUserlevel = data.map(d=>d.name)
    //           this.showUserlevel.unshift('All User Level')
    // 			}
    // 		});
    // },
    getReviewsNotVerifiedCount() {
      const filter = this.generateFilterReview();

      return this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews/count`, {
          params: {
            section: 'getReviewsNotVerifiedCount',
            filter: this.reduceFilter(filter),
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const data = res.data.data;
            this.counter.notVerified = data;
            if (data > 0) {
              this.counterInitial.notVerified = data;
            }
          }
        });
    },
    getReviewsExpertCount() {
      const filter = this.generateFilterReview();
      filter.push({ is_expert_reviewer: true });

      return this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews/count`, {
          params: {
            section: 'getReviewsExpertCount',
            filter: this.reduceFilter(filter),
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const data = res.data.data;
            this.counter.expert = data;
            if (data > 0) {
              this.counterInitial.expert = data;
            }
          }
        });
    },
    getReviewsVerifiedCount() {
      const filter = this.generateFilterReview();
      filter.push({ is_verified_purchase: true });

      return this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews/count`, {
          params: {
            section: 'getReviewsVerifiedCount',
            filter: this.reduceFilter(filter),
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const data = res.data.data;
            this.counter.verified = data;
            if (data > 0) {
              this.counterInitial.verified = data;
            }
          }
        });
    },
    async getLikedReviewsCount() {
      const filter = this.generateFilterReview();
      filter.push({ total_likes: { $gt: 0 } });

      return new Promise((resolve, reject) => {
        try {
          resolve(
            this.$MS_SOCO_PUBLIC_API_URL.get('/reviews/count', {
              params: {
                filter: this.reduceFilter(filter),
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      }).then((response) => {
        if (response.status === 200 && response.data && response.data.data) {
          this.counter.totalLiked = response.data.data;
        }
      });
    },
    async getReviewsCount(getLikedReviewsCount = true) {
      this.isLoadReview = true;
      const promise = [
        this.getReviewsExpertCount(),
        this.getReviewsVerifiedCount(),
        this.getReviewsNotVerifiedCount(),
        this.getReviewsWithPhotoCount(),
      ];
      if (getLikedReviewsCount) {
        promise.push(this.getLikedReviewsCount());
      }
      await Promise.all(promise).then(() => {
        // this.getreviewsData();
      });
    },
    getReviewsWithPhotoCount() {
      const filter = this.generateFilterReview();
      filter.push({ images: true });

      return this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews/count`, {
          params: {
            filter: this.reduceFilter(filter),
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const data = res.data.data;
            this.counter.withPhotos = data;
            if (data > 0) {
              this.counterInitial.withPhotos = data;
            }
          }
        });
    },
    getreviewsData(initialLoad = false) {
      if (initialLoad) {
        this.isLoadReview = true;
      }
      this.showFilter = null;
      //this.reviewsData = null

      this.$store.commit('review/SET_REVIEW', {
        reviews: '',
        on: 'product',
      });

      const filter = this.generateFilterReview();

      if (this.tabActive === 'expert-review') {
        filter.push({
          is_expert_reviewer: true,
        });
      }

      if (this.tabActive === 'trusted-review' || this.newFilters.verfiedReview == true) {
        filter.push({
          is_verified_purchase: true,
        });
      }

      if (this.tabActive === 'review-with-photos') {
        filter.push({ images: true });
      }

      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews`, {
          params: {
            skip: this.skip,
            sort: this.newSorter,
            limit: this.limit,
            filter: this.reduceFilter(filter),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            const data = res.data.data;
            // this.reviewsData = data;
            this.$store.commit('review/SET_REVIEW', {
              reviews: data,
              on: 'product',
            });
            this.addJsonLd();
          }

          this.isLoadReview = false;
        })
        .catch((err) => {
          // console.log(err);
          this.isLoadReview = false;
        });
    },
    loadMore($state) {
      this.isProcessingLoadMore = true;
      const filter = this.generateFilterReview();

      if (this.tabActive === 'review-with-photos') {
        filter.push({ images: true });
      }

      if (this.tabActive === 'expert-review') {
        filter.push({ is_expert_reviewer: true });
      }

      if (this.tabActive === 'trusted-review') {
        filter.push({
          is_verified_purchase: true,
        });
      }
      this.skip += this.limit;

      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/reviews`, {
          params: {
            skip: this.skip,
            sort: this.newSorter,
            limit: this.limit,
            filter: this.reduceFilter(filter),
          },
        })
        .then((res) => {
          if (res.status === 200) {
            const data = res.data.data;
            //this.reviewsData = this.reviewsData.concat(data)
            this.$store.commit('review/MERGE_REVIEW', {
              reviews: data,
              on: 'product',
            });

            if (!this.isActiveInfiniteLoadingState) {
              this.isActiveInfiniteLoadingState = true;
            }
            if ($state && this.$SO.size(data)) {
              $state.loaded();
            } else {
              if ($state) {
                $state.complete();
              }
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
          this.isProcessingLoadMore = false;
        })
        .catch((err) => {
          // console.log(err);
          this.isProcessingLoadMore = false;
          if ($state) {
            $state.complete();
          }
        });
    },
    loginOtf() {
      Auth.CentralAuth.login();
    },
    generateFilterReview() {
      const mergeParamFilters = [{ is_published: true }, { elastic_search: true }];
      const skinFilter =
        this.newFilters.concern && this.newFilters.concern.length ? this.newFilters.concern : this.newFilters.skin;

      if (skinFilter && skinFilter.length) {
        if (this.product.categories && this.product.categories[0].name === 'Hair Care') {
          mergeParamFilters.push({ 'user.hair_types.id': { $in: skinFilter } });
        } else {
          mergeParamFilters.push({ 'user.skin_types.id': { $in: skinFilter } });
        }
      }

      if (this.product_id) {
        mergeParamFilters.push({ product_id: this.product_id });
      }

      if (this.newFilters.rating && this.newFilters.rating.length) {
        mergeParamFilters.push({
          average_rating: this.newFilters.rating.map((rating) => {
            return {
              $gte: rating,
              $lt: Number(rating) + 0.999,
            };
          }),
        });
      }

      if (this.newFilters.combinations && this.newFilters.combinations.length) {
        mergeParamFilters.push({ 'product.combination.id': { $in: this.newFilters.combinations } });
      }

      if (this.newFilters.valueAge && this.newFilters.valueAge.length) {
        mergeParamFilters.push(this.newFilters.valueAge.reduce((obj, rating) => Object.assign(obj, rating), {}));
      }

      if (!this.newFilters.sort) {
        this.setDefault();
      }

      return mergeParamFilters;
    },
    reduceFilter(filter) {
      return filter.reduce((obj, item) => Object.assign(obj, item), {});
    },
    fetchAll() {
      this.resetAll();
      this.setDefault();
      this.getReviewsCount(false);
      this.getreviewsData(true);
    },
  },
};
</script>

<style lang="scss" scoped>
$lato_bold: 'Lato-Bold', sans-serif;
$lato_regular: 'Lato-Regular', sans-serif;

@mixin flexCenter() {
  display: flex;
  align-items: center;
}

@mixin listNone() {
  list-style: none;
  display: inline-flex;
  padding: 0;
}

@mixin fontHeader() {
  font-family: $lato_regular;
  font-size: 13px;
}

@mixin hideWebkitScrollbar() {
  &::-webkit-scrollbar {
    display: none;
  }
}
#pills-dropdown-mobile::v-deep {
  .modal-dialog {
    width: 100%;
    margin: 0;
    align-self: flex-end;
    height: max-content;
    max-height: 585px;
    overflow-y: auto;
    border-radius: 18px 18px 0 0;
    .modal-content {
      .modal-header {
        padding: 0;
        .rectangle-top {
          background: #efefef;
          border-radius: 8px;
          height: 3px;
          width: 38px;
          margin: 8px auto;
        }
        .modal-heading {
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0;
          &--title {
            margin-top: 0;
            margin-bottom: 0;
            font-family: 'lato-bold', sans-serif;
            font-size: 14px;
            color: #231f20;
            letter-spacing: normal;
            line-height: 18px;
          }
          &--close {
            position: initial;
            margin-top: 0;
            line-height: 0;
          }
        }
      }
      .modal-body {
        padding: 0;
        .pills-dropdown-mobile--list {
          margin-bottom: 24px;
          > li {
            padding: 12px 16px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.87);
            text-align: left;
            line-height: 24px;
            &.active {
              @include flexCenter();
              justify-content: space-between;
              p {
                font-family: $lato_bold;
              }
              &::after {
                content: url('/assets/img/icon-check-success-pink.svg');
                line-height: 0;
              }
            }
            &.has-subtags {
              padding: 0;
              margin-bottom: 2px;
            }
            &.apply-button {
              padding: 24px 16px;
              margin-bottom: -24px;
              button {
                width: 100%;
              }
            }
            &:not(.has-subtags) {
              cursor: pointer;
            }
            p {
              margin-top: 0;
              margin-bottom: 0;
              font-family: $lato_regular;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.87);
              text-align: left;
              line-height: 24px;
              &.has-subtags {
                font-family: $lato_bold;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 16px;
                background-color: #f5f5f5;
                cursor: pointer;
                img {
                  transform: rotate(0deg);
                  transition: transform 1s ease-in-out;
                }
                &.expanded {
                  img {
                    transform: rotate(180deg);
                  }
                }
              }
            }
            .rate-star--uniform {
              padding: 0;
              margin: 0;
              width: auto;
              span {
                width: 18px;
                height: 16px;
                background-size: 18px 16px;
                &::before {
                  width: 18px;
                  height: 16px;
                  background-size: 18px 16px;
                }
              }
              .icon_star::before {
                position: relative;
                top: -0.5px;
                margin-left: 1px;
                color: #e5e5e5;
              }
            }
            .subtags {
              max-height: 0;
              overflow: hidden;
              transition: max-height 1s ease-in-out;
              &.expanded {
                max-height: 800px;
              }
              p {
                @include flexCenter();
                padding: 0 16px 0 32px !important;
                margin-top: 16px;
                margin-bottom: 16px;
                input[type='checkbox'] {
                  margin-top: 0;
                  height: 16px;
                  width: 16px;
                  cursor: pointer;
                  &:after {
                    height: 16px;
                    width: 16px;
                    border: 1px solid #e5e5e5;
                    border-radius: 4px;
                    top: 0;
                  }
                  &:checked::after {
                    height: 16px;
                    width: 16px;
                    border: none;
                  }
                }
                label {
                  cursor: pointer;
                  margin: 0;
                  padding: 0;
                  flex: 1;
                }
              }
            }
            .shade-combination {
              @include flexCenter();
              img {
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
            &::v-deep {
              .shade-combination--image {
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
